import React from 'react'

import { propFunc } from 'util/functions'

import styles from './styles.less'

export default function DatePickerPreset({ onApply, text, timeframe }) {
  return (
    <span
      className={styles.DatePickerDateRangeItem}
      data-test-id={`preset-${timeframe}`}
      onClick={propFunc(onApply, timeframe)}
    >
      {text}
    </span>
  )
}
